// ─── Pont de migration : tenants HÉRITÉS ──────────────────────────
// Avant la suite, chaque donnée métier était rattachée à un CALENDRIER MoPCal.
// Dans la suite, elle est rattachée à un ESPACE. Un espace peut donc « adopter »
// un ou plusieurs tenants historiques : `espaces/{id}.tenantsHerites = [calId…]`.
//
// Conséquences, voulues :
//   • les modules LISENT sur l'union { espaceId } ∪ { tenants hérités } ;
//   • ce qu'on ÉCRIT dans un tenant hérité reste visible par MoPCal — les deux
//     applications continuent de travailler sur les mêmes données ;
//   • le jour du cutover, on migre les documents et cette liste se vide.
//
// C'est le SEUL endroit du Core qui connaît le nom de la collection historique
// `calendriers`. Isolé ici exprès : ce fichier est destiné à disparaître.
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase';

// Tenants historiques dont l'utilisateur est participant, adoptables par un espace.
export function ecouterTenantsHeritables(uid, callback, onErreur) {
  if (!uid) { callback([]); return () => {}; }
  const q = query(collection(db, 'calendriers'), where('participants', 'array-contains', uid));
  return onSnapshot(
    q,
    (snap) => {
      const l = snap.docs
        // Les calendriers IVV relèvent de LEUR bascule (« Voir les calendriers
        // IVV »), pas de la superposition perso : un valideur qui figure dans
        // leurs `participants` les voyait réapparaître ici malgré la bascule
        // fermée — deux mécanismes pour la même liste, donc une contradiction.
        .filter(d => !(d.data() || {}).ivv)
        .map(d => {
          const c = d.data() || {};
          return { id: d.id, nom: c.nom || 'Calendrier', emoji: c.icone || '📅', origine: 'mop-cal' };
        });
      l.sort((a, b) => (a.nom || '').localeCompare(b.nom || ''));
      callback(l);
    },
    (e) => { callback([]); onErreur?.(e); },
  );
}
